var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconErrorboundary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    height: "512px",
    id: "Layer_1",
    viewBox: "0 0 512 512",
    width: "512px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M115.892,480c-85.8,0-120.84-60.627-77.865-134.889l140.131-242.089    c42.974-74.262,113.295-74.229,156.269,0.033l140.131,242.039C517.531,419.357,482.492,480,396.691,480H115.892z",
    fill: "#F9BC12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.892,480c-85.8,0-120.84-60.627-77.865-134.889l140.131-242.089    c42.974-74.262,113.295-74.229,156.269,0.033l140.131,242.039C517.531,419.357,482.492,480,396.691,480H115.892z",
    fill: "#F9BC12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.557,345.089L334.426,103.066c-26.446-45.7-63.247-63.291-97.659-52.758    c21.525,6.588,42.118,24.158,58.659,52.742l140.131,242.041C478.531,419.354,443.492,480,357.691,480h39    C482.492,480,517.531,419.351,474.557,345.089z",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.892,480c-85.8,0-120.84-60.627-77.865-134.889l140.131-242.089    c42.974-74.262,113.295-74.229,156.269,0.033l140.131,242.039C517.531,419.357,482.492,480,396.691,480H115.892z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 255.913,
    cy: 388.251,
    fill: "#2E2E2E",
    r: 22.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M278,331c0,11.046-8.954,20-20,20h-4c-11.046,0-20-8.954-20-20V163c0-11.046,8.954-20,20-20h4     c11.046,0,20,8.954,20,20V331z",
    fill: "#2E2E2E"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconErrorboundary);
export default __webpack_public_path__ + "static/media/icon_errorboundary.f33256e847756706dffdac4feed893d2.svg";
export { ForwardRef as ReactComponent };